import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";



function RepeatedPYQPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="repeatedpyq" />

    </>
  );
}

export default RepeatedPYQPhysTopics;